import useStyle from './index.styles';
import { getFormattedDateToShow } from '../../utils';
import AvatarMemorial from '../../DLS/Avatar';

interface Props {
  firstName: string;
  lastName: string;
  date: string;
  copy: string;
  profileImageUrl: string;
}

const CommentCard = (props: Props) => {
  const { copy, date, firstName, lastName, profileImageUrl } = props;
  const classes = useStyle();
  return (
    <div className={`mb-[16px] rounded-[8px] bg-white p-[16px] md:p-[24px] ${classes.box}`}>
      <div className="mb-[8px] flex md:mb-[16px]">
        <div className="mr-[8px]">
          <AvatarMemorial
            image={profileImageUrl}
            initials={firstName ? `${firstName[0]}${lastName[0]}` : ''}
            size={48}
          />
        </div>
        <div>
          <p className="font-IBMPlexSansSemiBold">{`${firstName} ${lastName}`}</p>
          <p className="smallParagraph mt-[4px]">{getFormattedDateToShow(date)}</p>
        </div>
      </div>
      <p className="md:pl-[56px]">{copy}</p>
    </div>
  );
};

export default CommentCard;
